<template>
  <helper-layout :loaded="mx_loaded">
    <material-table
      :headers="headers"
      :search-data="searchData"
      :paginate="paginateConfig"
      :items="inStockData.items"
      :total-count="inStockData.totalCount"
      @pageChange="handlePageChange"
      @searchChange="handleSearchChange"
    >
      <template v-slot:toolbar>
        <v-layout justify-space-between>
          <v-flex shrink>
            <v-btn
              small
              class="bg-btn"
              @click="() => $router.push({ name: 'createInStock' })"
            >
              <!-- 新增 -->
              {{ $t("Core.System.create") }}
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </material-table>
    <material-dialog
      :width="400"
      :visible="deleteConfirmDialog.show"
      :title="$t('Views.Stock.deleteStockDialogTitle')"
      @cancleFn="() => (deleteConfirmDialog.show = false)"
      @confirmFn="deleteOk"
    >
      <template>
        <v-icon :color="color">
          mdi-alert
        </v-icon><span>{{ $t("Views.Stock.deleteStockDialogContent") }}</span>
      </template>
    </material-dialog>
  </helper-layout>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'
import ENUMS from '@/dict/enums'
import tool from '@/utils/tool'

export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      headers: [
        {
          // '单据号'
          text: $t('Views.Stock.stockSerialNumber'),
          value: 'number'
        },
        {
          // '入库类型'
          text: $t('Views.Stock.inStockCategory'),
          value: 'type',
          render: (h, params) => {
            return h(
              'div',
              {
              },
              ENUMS.InStockCategory[params.row.type]
            )
          }
        },
        {
          // '数量'
          text: $t('Views.Stock.quantity'),
          value: 'quantity'
        },
        {
          // '经办人'
          text: $t('Views.Stock.operator'),
          value: 'operator'
        },
        {
          // '入库时间'
          text: $t('Views.Stock.inStockTime'),
          value: 'stockTime',
          type: 'date'
        },
        {
          // '状态'
          text: $t('Views.Stock.status'),
          type: 'status',
          value: 'status',
          render: (h, params) => {
            return h(
              'div',
              {
                style: {
                  color: ENUMS.isActive[params.row.status !== 'Pending'].color
                },
                class: 'status'
              },
              ENUMS.InStockStatus[params.row.status]
            )
          }
        },
        {
          // '操作'
          text: $t('Views.Stock.action'),
          value: 'action',
          actions: [
            {
              // 查看
              text: $t('Views.Stock.view'),
              color: this.$store.state.app.color,
              visible: true,
              actionFn: row => {
                this.$router.push({
                  name: 'inStockDetail',
                  params: { id: row.row.id }
                })
              }
            },
            {
              // 修改
              text: $t('Core.System.edit'),
              color: 'secondary',
              visible: param => {
                return param.row.status === 'Pending'
              },
              actionFn: row => {
                this.$router.push({
                  name: 'editInStock',
                  query: { id: row.row.id }
                })
              }
            },
            {
              // 审核
              text: $t('Core.System.review'),
              color: 'secondary',
              visible: param => {
                return param.row.status === 'Pending'
              },
              actionFn: row => {
                this.$router.push({
                  name: 'reviewInStock',
                  query: { id: row.row.id }
                })
              }
            },
            {
              // 删除
              text: $t('Core.System.delete'),
              color: 'secondary',
              visible: param => {
                return param.row.status === 'Pending'
              },
              actionFn: row => {
                this.deleteConfirmDialog.show = true
                this.deleteConfirmDialog.deleteId = row.row.id
              }
            }]
        }
      ],
      searchData: [
        {
          key: 'number',
          value: '',
          // 单据号
          label: $t('Views.Stock.stockSerialNumber'),
          placeholder: $t('Views.Stock.stockSerialNumber')
        },
        {
          key: 'stockType',
          value: '',
          type: 'select',
          // 入库类型
          label: $t('Views.Stock.inStockCategory'),
          placeholder: $t('Views.Stock.inStockCategory'),
          state: tool.enumToSelect(ENUMS.InStockCategory)
        },
        {
          key: 'dateRange',
          type: 'daterange',
          // 入库时间
          label: $t('Views.Stock.inStockTime'),
          value: {},
          placeholder: $t('Views.Stock.inStockTime')
        },
        {
          key: 'operatorId',
          id: '',
          // 经办人
          name: $t('Views.Stock.operator'),
          placeholder: $t('Views.Stock.operator'),
          type: 'select',
          itemText: 'name',
          itemValue: 'id',
          itemState: 'items',
          items: []
        },
        {
          key: 'status',
          value: '',
          type: 'select',
          // 入库类型
          label: $t('Views.Stock.status'),
          placeholder: $t('Views.Stock.status'),
          state: tool.enumToSelect(ENUMS.InStockStatus)
        }
      ],
      paginateConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      form: {
        skipCount: 0,
        maxResultCount: 10
      },
      deleteConfirmDialog: {
        show: false,
        deleteId: ''
      }
    }
  },
  computed: {
    ...mapState('stock', ['inStockData']),
    ...mapState('setting', ['staffAllData']),
    color() {
      return this.$store.state.app.color
    }
  },
  mounted() {
    this.getPage()
    this.getStaffList()
  },
  methods: {
    ...mapActions('stock', ['getInStockData', 'deleteInStock']),
    ...mapActions('setting', ['getStaffAllData']),
    getPage(page) {
      if (typeof page !== 'undefined') {
        this.paginateConfig.page = page
        this.form.skipCount = (page - 1) * this.form.maxResultCount
      }
      this.mx_loading_fn() // 页面加载中
      this.getInStockData(this.form).then(() => {
        this.paginateConfig.total = this.inStockData.totalCount
        this.mx_loaded_fn() // 页面加载完成
      })
    },
    handlePageChange(page) {
      this.getPage(page)
    },
    handleSearchChange(search) {
      delete this.form.stockBeginTime
      delete this.form.stockEndTime
      this.form = { ...this.form, ...search }
      if (search.dateRange) {
        this.form = { ...this.form, ...{ stockBeginTime: search.dateRange.start }, ...{ stockEndTime: search.dateRange.end }}
      }
      delete this.form.dateRange
      this.getPage(1, true)
    },
    getStaffList() {
      this.getStaffAllData().then(() => {
        this.searchData[3].items = this.staffAllData.items
      })
    },
    deleteOk(id) {
      this.deleteInStock(this.deleteConfirmDialog.deleteId).then(() => {
        this.deleteConfirmDialog.show = false
        this.deleteConfirmDialog.deleteId = ''
        this.getPage(this.paginateConfig.page)
      })
    }
  }
}
</script>

<style>
</style>
